import PropTypes from "prop-types"
import React from "react"
import { useLocation } from "react-router-dom"
import styled from "styled-components"

import Paragraph from "../../../../_shared/components/Typography/Paragraph"

import OkIcon from "../../../../_shared/images/ok.png"

// ----------------------------------------------------------------------------

function Booking(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const { search } = useLocation()
    const query = new URLSearchParams(search)
    const status = query.get("status") || "success"

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    if (status === "error") {
        return (
            <div className={`${props.className} error`}>
                <main className="screen-title">
                    <h1>Errore durante la creazione della prenotazione</h1>
                    <Paragraph className="paragraph">
                        Siamo spiacenti, la sua prenotazione non è andata a buon
                        fine a causa di un errore tecnico. Effettui un nuovo
                        tentativo oppure contatti {"l'amministrazione"} per
                        ricevere assistenza.
                    </Paragraph>
                </main>
            </div>
        )
    }

    return (
        <div className={props.className}>
            <main>
                <h1 className="screen-title">
                    <img src={OkIcon}></img>
                    <span>Prenotazione effettuata correttamente!</span>
                </h1>
                <Paragraph className="paragraph">
                    {
                        "A breve riceverai una e-mail con tutti i dettagli per trovarti pronta."
                    }
                </Paragraph>
                <Paragraph className="paragraph">
                    {
                        "Per <b>rientrare nella tua prenotazione</b> dal nostro sito, inserisci se necessario il <b>codice fiscale</b> ed entrerai automaticamente nella sezione “I tuoi biglietti”."
                    }
                </Paragraph>
                <Paragraph className="paragraph">
                    {
                        "<b>ATTENZIONE:</b> se la mail di conferma non arriva controllare in spam o di aver inserito correttamente la mail al momento della prenotazione."
                    }
                </Paragraph>
            </main>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

Booking.propTypes = {
    className: PropTypes.string.isRequired,
}

Booking.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledBooking = styled(Booking)`
    & {
        &.error {
            main {
                h1 {
                    color: ${({ theme }) => theme.colors.errorColor};
                }
            }
        }
        main {
            padding-top: 80px;
            display: flex;
            align-items: center;
            flex-direction: column;
            h1 {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                img {
                    margin-right: 10px;
                }
                span {
                    font-size: 32px;
                    color: ${({ theme }) => theme.colors.success};
                    font-family: "Poppins-Bold";
                }
            }
            .paragraph {
                text-align: center;
                padding: 0px 30px;

                &:first-of-type {
                    margin-top: 30px;
                }
                &:last-of-type {
                    margin-top: 10px;
                }
            }
            .doc-list {
                list-style: none;
                margin: 0;
                padding: 0;
                .doc {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-bottom: 20px;
                    .doc-link {
                        text-decoration: underline;
                        font-family: "Poppins-Bold";
                        font-size: 16px;
                        color: ${({ theme }) => theme.colors.textPrimary};
                    }
                    .list-counter {
                        width: 25px;
                        height: 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 1px solid black;
                        border-radius: 999px;
                        margin-right: 20px;
                        font-family: "Poppins-Bold";
                        font-size: 12px;
                    }
                }
            }
        }
        @media (max-width: 768px) {
            h1 {
                width: 75% !important;
                text-align: center;
                flex-direction: column !important;
                img {
                    margin-bottom: 20px;
                    margin-right: 0px !important;
                }
            }
        }
        @media (max-width: 576px) {
            .paragraph {
                padding: 0px 30px;
            }

            main {
                max-width: 100vw;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledBooking
